///Users/kacey/BoxyQR_Website/BoxyQR/boxyQR_website/client/src/pages/CreateLinkShort.js

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom'; // Added Link
import { useUser } from '@clerk/clerk-react';

function CreateLinkShort() {
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // New state variables for tracking limits
  const [linkShortCount, setLinkShortCount] = useState(0);
  const [linkShortLimit, setLinkShortLimit] = useState(10); // Default free plan limit
  const [account, setAccount] = useState(null);
  const [daysRemaining, setDaysRemaining] = useState(14);

  // Check for URL from previous page and fetch account/link data
  useEffect(() => {
    if (location.state?.url) {
      setUrl(location.state.url);
    }
    
    const fetchUserData = async () => {
      try {
        if (!user) return;
        
        // Fetch account information
        const accountResponse = await fetch(`/api/account?user_id=${user.id}`);
        if (accountResponse.ok) {
          const accountData = await accountResponse.json();
          console.log('Account data:', accountData);
          setAccount(accountData);
          
          // Set link limit based on plan
          // if (accountData.plan === 'free_trial') {
          //   setLinkShortLimit(10);
          // } 
          if (accountData.plan.startsWith('basic_')) {
            setLinkShortLimit(10); // Unlimited for basic plans
          } else if (accountData.plan && accountData.plan.startsWith('plus_')) {
            setLinkShortLimit(500)
          } 
         else if (accountData.plan && accountData.plan.startsWith('free_')) {
          setLinkShortLimit(10)
        } 
           else {
            setLinkShortLimit(1000); // Unlimited for business plans
          }


          
          // Calculate days remaining if on free plan
          // if (accountData.plan === 'free_trial') {
          //   try {
          //     // Check if createdAt exists
          //     if (accountData.createdAt) {
          //       const createdDate = new Date(accountData.createdAt);
          //       const today = new Date();
          //       const trialEndDate = new Date(createdDate);
          //       trialEndDate.setDate(trialEndDate.getDate() + 14); // 14-day trial
                
          //       // Calculate the difference in days
          //       const timeDiff = trialEndDate.getTime() - today.getTime();
          //       const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                
          //       // If days remaining is negative, set to 0
          //       const remainingDays = Math.max(0, daysDiff);
          //       console.log('Days remaining in trial:', remainingDays);
          //       setDaysRemaining(remainingDays);
          //     } else {
          //       // If no creation date, default to 14 days
          //       console.log('No creation date found, defaulting to 14 days');
          //       setDaysRemaining(14);
          //     }
          //   } catch (dateErr) {
          //     console.error('Error calculating remaining days:', dateErr);
          //     setDaysRemaining(14); // Default fallback
          //   }
          // }
        }
        
        // Fetch link shorts count
        const linkResponse = await fetch(`/api/linkshorts?user_id=${user.id}`);
        if (linkResponse.ok) {
          const linkData = await linkResponse.json();
          setLinkShortCount(linkData.length);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    
    fetchUserData();
  }, [user, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if user has reached their link limit
    if (linkShortCount >= linkShortLimit) {
      setError('You have reached your trackable link limit. Please upgrade your plan to create more links.');
      return;
    }
    
    setLoading(true);
    setError('');

    try {
      // Format URL by adding https:// if not present
      let formattedUrl = url.trim();
      if (!formattedUrl.match(/^https?:\/\//i)) {
        formattedUrl = `https://${formattedUrl}`;
      }

      const userData = {
        user_id: user ? user.id : "fixed_user_123",
        email_address: user ? user.primaryEmailAddress.emailAddress : "user@example.com"
      };

      const response = await fetch('/api/linkshorts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          targetUrl: formattedUrl, // Use the formatted URL
          user_id: userData.user_id,
          email_address: userData.email_address
        }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to create link short');
      }

      // Redirect to the links page on success
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="mt-6 text-3xl font-bold mb-6">Create a Trackable Link</h1>
      
      {/* Free Plan Banner with Days Remaining */}
      {account && account.plan === 'free_trial' && (
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-700">
                {!isNaN(daysRemaining) ? (
                  <>Your links are only active for {daysRemaining} more day{daysRemaining !== 1 ? 's' : ''}.</>
                ) : (
                  <>Your links are only active for 14 days.</>
                )}
                {' '}
                <Link to="/upgrade" className="font-medium underline text-blue-700 hover:text-blue-600">
                  Upgrade now
                </Link> to keep them active.
              </p>
            </div>
          </div>
        </div>
      )}

      {error && <div className="bg-red-100 text-red-700 p-4 rounded-lg mb-4">{error}</div>}

      {/* Link Usage Indicator */}
      {/* {account && account.plan === 'free_basic' && ( */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <p className="text-sm font-medium text-gray-700">
              Links Created: <span className="font-bold">{linkShortCount} of {linkShortLimit}</span>
            </p>
            {linkShortCount >= linkShortLimit && (
              <Link 
                to="/upgrade" 
                className="text-sm text-blue-600 hover:text-blue-800 font-semibold"
              >
                Upgrade to create more
              </Link>
            )}
          </div>
          
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div 
              className="bg-blue-600 h-2.5 rounded-full" 
              style={{ width: `${Math.min(linkShortCount / linkShortLimit * 100, 100)}%` }}
            ></div>
          </div>
        </div>
      {/* )} */}

      {/* Warning Banner when limit reached */}
      {account && account.plan === 'basic_plus' || account && account.plan === 'free_basic' && linkShortCount >= linkShortLimit && (
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-yellow-700">
                You've reached your limit of 10 trackable links on the free plan. 
                <Link to="/upgrade" className="font-medium underline text-yellow-700 hover:text-yellow-600 ml-1">
                  Upgrade now
                </Link> to create more links and access advanced features.
              </p>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
        <div className="mb-4">
          <label className="block mt-2 text-m text-gray-700 font-semibold mb-1">
            URL to track:
          </label>
          <input
            type="text"
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder=" https://example.com"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
          <p className="text-sm text-gray-400 mt-1">Enter the URL you want to link to and track views for</p>
        </div>

        <button
          type="submit"
          className={`w-full py-3 rounded font-semibold transition duration-200 ${
            linkShortCount >= linkShortLimit && account?.plan === 'free_trial'
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-700 hover:bg-blue-800 text-white'
          }`}
          disabled={loading || (linkShortCount >= linkShortLimit && account?.plan === 'free_trial')}
        >
          {loading ? 'Creating...' : 
            linkShortCount >= linkShortLimit && account?.plan === 'free_trial'
              ? 'Upgrade to Create More Links'
              : 'Create Trackable Link'}
        </button>
        
        {linkShortCount >= linkShortLimit && account?.plan === 'free_trial' && (
          <Link
            to="/upgrade"
            className="block w-full text-center mt-3 text-blue-600 hover:text-blue-800 font-medium"
          >
            View Upgrade Options
          </Link>
        )}
      </form>
    </div>
  );
}

export default CreateLinkShort;